"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpectralShieldAbilityHandler = exports.SpectralShieldActorAbilityFactory = exports.SpectralShieldAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const Settings_1 = require("../../Settings");
class SpectralShieldAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SpectralShield;
        this.__typeName = "SpectralShield";
    }
}
exports.SpectralShieldAbilityArgs = SpectralShieldAbilityArgs;
let SpectralShieldActorAbilityFactory = class SpectralShieldActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SpectralShield", "AllAllies", 4);
    }
};
SpectralShieldActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SpectralShield")
], SpectralShieldActorAbilityFactory);
exports.SpectralShieldActorAbilityFactory = SpectralShieldActorAbilityFactory;
let SpectralShieldAbilityHandler = class SpectralShieldAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                for (const allyId of container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)) {
                    container.applyBuff({
                        sequence: sequence.pushSequence("sequential"),
                        creatorId: ability.invokerId,
                        targetId: allyId,
                        effect: new __1.LinkedEffectsEffectArgs([
                            new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.AllDamageResistance, Settings_1.BASE_LEVEL_ADR * container.getLevel(ability.invokerId)),
                            new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.Will, container.getPercentOfBaseAttributeScore(allyId, 10, "Will")),
                        ], false),
                        duration: Duration_1.Duration.Turns(4),
                        onApplied(sequence) {
                            sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(allyId, "chest"), "MagicBubble"));
                        }
                    });
                }
            }
        });
    }
};
SpectralShieldAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SpectralShield)
], SpectralShieldAbilityHandler);
exports.SpectralShieldAbilityHandler = SpectralShieldAbilityHandler;
